import { useState, useEffect } from "react";
import apiClient from "../../../api/apiClient";

export const useBundleDetail = (bundleListingsId) => {
  const [loader, setloader] = useState(false);
  const [bundleListingsById, setBundleListingsById] = useState(null);

  const fetchBundleDetail = async () => {
    try {
      setloader(true);
      const result = await apiClient.get(
        `/bundle-listings/${bundleListingsId}/`
      );
      if (!result.ok) return;
      setBundleListingsById(result?.data || {});
      setloader(false);
      return result?.data;
    } catch (error) {
      setloader(false);
    }
  };

  useEffect(() => {
    if (bundleListingsId) {
      fetchBundleDetail();
    }
  }, [bundleListingsId]);

  return { bundleListingsById, loader, fetchBundleDetail };
};

